<template>
  <!-- Cena -->
  <div>
    <aw-dropdown
      @show="onShow"
      @hide="onHide"
      class="dropdown relative"
      placement="bottom-start"
      :offset="[0, 24]"
    >
      <template #btn="{ toggle, opened }">
        <span
          @click="toggle"
          class="inline-flex items-center text-xs md:text-p1 cursor-pointer relative z-10 py-2 pr-4 select-none"
          :class="{ 'text-ambi-red': opened }"
        >
          Cena

          <aw-icon
            icon="chevron-down"
            class="w-6 h-6 transition-transform transform text-ambi-red"
            :class="{ 'rotate-180': opened }"
          />
        </span>
      </template>

      <template #dropdown="{ opened, dropdown, close }">
        <teleport to="body">
          <div
            v-show="opened"
            :ref="dropdown"
            style="width: 100%; max-width: 400px"
            @click.stop="close"
            @touchstart.stop="close"
            class="DropdownAmbi absolute z-20 py-3 px-4 /*!-left-px*/ top-full bg-white rounded-2xl border-divider-dark border-2"
          >
            <div class="relative">
              <span
                class="absolute inline-flex items-center text-h4 z-10 py-0 pr-4 select-none -top-8"
                :class="insideStickyPanel ? 'right-4' : '-left-4'"
              >
                <span class="invisible">Cena</span>
                <span class="Beak -Top"></span>
              </span>

              <span
                class="absolute inline-flex items-center text-h4 z-10 py-0 pr-4 select-none -bottom-8"
                :class="insideStickyPanel ? 'right-4' : '-left-4'"
              >
                <span class="invisible">Cena</span>
                <span class="Beak -Bottom"></span>
              </span>

              <div>
                <h3 class="text-h4 mb-2">Seřadit dle:</h3>

                <div
                  v-for="(priceSort, key) in priceSortList"
                  @click="filtersStorage.priceSort = key"
                  :key="key"
                  class="flex items-center cursor-pointer group py-2"
                >
                  <div
                    class="flex-1 pr-2 group-hover:text-ambi-red text-p1"
                    :class="{ 'text-ambi-red': filtersStorage.priceSort === key }"
                  >
                    {{ priceSort.label }}
                  </div>
                  <div class="w-5">
                    <div
                      class="RadioIndicator"
                      :class="{
                        '-Selected': filtersStorage.priceSort === key
                      }"
                    >
                      <span><aw-icon icon="tick" class="w-5 h-5 text-white" /></span>
                    </div>
                  </div>
                </div>

                <hr class="my-3" />

                <h3 class="text-h4 mb-2">Nastavení ceny</h3>

                <div
                  v-for="(priceValue, key) in priceValueList"
                  @click="filtersStorage.priceValue = key"
                  :key="key"
                  class="flex items-center cursor-pointer group py-2"
                >
                  <div
                    class="flex-1 pr-2 group-hover:text-ambi-red text-p1"
                    :class="{ 'text-ambi-red': filtersStorage.priceValue === +key }"
                  >
                    {{ priceValue.label }}
                  </div>
                  <div class="w-5">
                    <div
                      class="RadioIndicator"
                      :class="{ '-Selected': filtersStorage.priceValue === +key }"
                    >
                      <span><aw-icon icon="tick" class="w-5 h-5 text-white" /></span>
                    </div>
                  </div>
                </div>

                <button
                  @click="close"
                  type="button"
                  class="flex w-full p-2 justify-center text-ambi-red"
                >
                  <span class="sr-only">Dismiss</span>
                  <aw-icon icon="close" class="h-7 w-7" aria-hidden="true" />
                </button>
              </div>
            </div>
          </div>
        </teleport>
      </template>
    </aw-dropdown>
  </div>
</template>

<script>
import { inject } from 'vue'
import { priceSortList, priceValueList } from './DataCollectionList'
import useAmbiFilter from '../AmbiFilter'

export default {
  setup() {
    const onShow = inject('onShow')
    const onHide = inject('onHide')
    const insideStickyPanel = inject('insideStickyPanel')
    const { selectedFilters, filtersStorage } = useAmbiFilter()

    return {
      onShow,
      onHide,
      insideStickyPanel,
      priceSortList,
      priceValueList,
      selectedFilters,
      filtersStorage
    }
  }
}
</script>
